import type { MapType } from '@racemap/utilities/consts/events';
import { mapStyles } from '@racemap/utilities/consts/map';
import classNames from 'classnames';
import { type FC, useEffect } from 'react';
import { type IControl, type MapInstance, useControl } from 'react-map-gl/mapbox';

interface Props {
  value: MapType | null;
  onChange?: (newStyle: MapType) => void;
}

class MapboxStyleControlClass implements IControl {
  _container: HTMLElement | null = null;
  _map: MapInstance | undefined;
  onChange?: (newStyle: MapType) => void;
  value: MapType | null = null;

  constructor(value: MapType | null, onChange?: (newStyle: MapType) => void) {
    this.value = value;
    this.onChange = onChange;
  }

  renderStyleButtons() {
    if (this._container == null) return null;

    this._container.innerHTML = '';
    for (const [styleType, styleInfos] of Object.entries(mapStyles)) {
      const styleButton = document.createElement('button');
      styleButton.className = classNames('mapbox-ctrl-button-style');
      if (styleType === this.value) styleButton.classList.add('mapbox-ctrl-button-style-choosed');

      styleButton.title = styleInfos.label;
      styleButton.addEventListener('click', () => this.onChange?.(styleType as MapType));
      styleButton.innerHTML = styleInfos.label;
      this._container?.appendChild(styleButton);
    }
  }

  onAdd(map: MapInstance) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className =
      'mapboxgl-ctrl mapboxgl-ctrl-group mapxboxgl-ctrl-style-chooser mapboxgl-ctrl-group-vertical';
    this._container.addEventListener('contextmenu', (e) => e.preventDefault());

    this.renderStyleButtons();

    return this._container;
  }

  onRemove() {
    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
  }
}

export const MapboxStyleControl: FC<Props> = ({ value, onChange }) => {
  const ctrl = useControl<MapboxStyleControlClass>(
    () => new MapboxStyleControlClass(value, onChange),
    {
      position: 'top-left',
    },
  );

  useEffect(() => {
    ctrl.value = value;
    ctrl.onChange = onChange;
    ctrl.renderStyleButtons();
  }, [value, onChange, ctrl]);

  return null;
};
